// src/services/postageLabelsService.js
import { pb } from "./pocketbase";

export const postageLabelsService = {
  /**
   * Busca as etiquetas e PDFs cacheados de um pedido específico.
   */
  async getShipment(orderNumber) {
    if (!orderNumber) return null;
    try {
      const result = await pb.collection("postage_labels").getFirstListItem(`order_number="${orderNumber}"`);
      return result;
    } catch (error) {
      // Se não for encontrado (404), apenas retorna null silenciosamente
      if (error.status === 404) {
        return null;
      }
      console.error(`Erro ao obter postage_labels para o pedido #${orderNumber}:`, error);
      return null;
    }
  },

  /**
   * Cria ou atualiza informações básicas de envio (rastreio, pré-postagem).
   */
  async saveShipment(orderNumber, trackingCode, correiosPrepostagemId) {
    try {
      const existing = await this.getShipment(orderNumber);
      const data = {
        order_number: orderNumber,
        tracking_code: trackingCode || "",
        correios_prepostagem_id: correiosPrepostagemId || "",
      };

      if (existing) {
        return await pb.collection("postage_labels").update(existing.id, data);
      } else {
        return await pb.collection("postage_labels").create(data);
      }
    } catch (error) {
      console.error(`Erro ao gravar dados de envio para o pedido #${orderNumber}:`, error);
      throw error;
    }
  },

  /**
   * Faz o upload de um arquivo PDF gerado dinamicamente para o PocketBase.
   * @param {string} orderNumber Número do pedido
   * @param {string} fieldName Nome do campo de arquivo no PocketBase ('etiqueta_pdf', 'danfe_pdf' ou 'certificados_pdf')
   * @param {Blob} pdfBlob O Blob binário do PDF
   * @param {string} fileName O nome que o arquivo receberá (ex: 'etiqueta_69584.pdf')
   */
  async uploadPdf(orderNumber, fieldName, pdfBlob, fileName) {
    try {
      const existing = await this.getShipment(orderNumber);
      const formData = new FormData();
      formData.append("order_number", orderNumber);
      formData.append(fieldName, pdfBlob, fileName);

      if (existing) {
        return await pb.collection("postage_labels").update(existing.id, formData);
      } else {
        return await pb.collection("postage_labels").create(formData);
      }
    } catch (error) {
      console.error(`Erro ao fazer upload do PDF (${fieldName}) para o pedido #${orderNumber}:`, error);
      throw error;
    }
  }
};
